import { Component, inject, signal } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { AccountService } from '@jfw/angular/shared/services';
import {
  CreateDealerUserComponent,
  DealerUserSavedEvent,
} from '../../../dealer-user/create-user/create-user.component';

export type AddDealerUserDialogData = { accountNumber: string };

@Component({
  selector: 'app-add-dealer-user-dialog',
  templateUrl: './add-dealer-user-dialog.component.html',
  styleUrls: ['./add-dealer-user-dialog.component.scss'],
  imports: [
    CreateDealerUserComponent,
    MatButton,
    MatDialogModule,
    MatIcon,
    MatIconButton,
  ],
})
export class AddDealerUserDialogComponent {
  private dialogRef = inject(MatDialogRef<AddDealerUserDialogComponent>);
  // The drawer's own AccountService, so its Users list updates behind the
  // dialog as soon as a save lands.
  private accountService = inject(AccountService);
  protected data = inject<AddDealerUserDialogData>(MAT_DIALOG_DATA);
  // Set once a save fully succeeds; swaps the form for a confirmation.
  protected readonly confirmation = signal<DealerUserSavedEvent | undefined>(
    undefined,
  );

  protected onSaved(event: DealerUserSavedEvent): void {
    // The user exists even when the invite email failed, so always refresh.
    this.accountService.loadDealerUsers(event.accountNumber);
    // On a failed invite the form stays up with its own error message.
    if (event.outcome !== 'inviteFailed') {
      this.confirmation.set(event);
    }
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
